"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportProducts = void 0;
const use_export_product_presentations_hook_1 = require("../../../../common/product-table/hooks/use-export-product-presentations.hook");
const products_table_1 = require("../../../../store/catalogs/products-table");
const store_1 = require("../../../../../store");
const useExportProducts = ({ catalogId, }) => {
    const tableFilter = (0, products_table_1.useProductsTableFilter)();
    const tableSearch = (0, products_table_1.useProductsTableSearch)();
    const tableSort = (0, products_table_1.useProductsTableSort)();
    const dynamicColumns = (0, products_table_1.useProductsTableDynamicColumns)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const selectedTreeNodeId = (0, store_1.useSelectedTreeNodeId)();
    const selectedAttributeNode = (0, store_1.useSelectedAttributeNode)();
    return (0, use_export_product_presentations_hook_1.useExportProductPresentations)({
        catalogId,
        productTreeId,
        productTreeNodeIds: selectedTreeNodeId ? [selectedTreeNodeId] : [],
        tableFilter,
        tableSearch,
        tableSort,
        dynamicColumns,
        selectedAttributeNode,
    });
};
exports.useExportProducts = useExportProducts;
